// @ts-nocheck

import globalVariables from "@/global";
import { EComService } from '@connectngo/sdk'

const FulfillmentMixin = {
	data: () => ({
		pdfButtonFF: false,
		fulfillmentCompleted: false,
		fulfillmentPollingInterval: null,
	}),

	created() {
		this.pdfButtonFF = globalVariables.websiteConfig.featureFlagEnabled('co-9619-disable-product-pdf-until-job-finishes')
	},

	beforeDestroy () {
		if (this.fulfillmentPollingInterval) {
			clearInterval(this.fulfillmentPollingInterval)
		}
	},

	methods: {
		startFulfillmentPolling (transactionId) {
			this.fulfillmentPollingInterval = setInterval(async () => {
				try {
					new EComService().getFulfillmentStatus(transactionId)
						.then(response => {
							if (response) {
								this.fulfillmentCompleted = response.data.ready

								if (this.fulfillmentCompleted) {
									clearInterval(this.fulfillmentPollingInterval)
								}
							}
						})
				} catch (e) {
					console.error('Error checking fulfillment status', e)
				}
			}, 3000) // check every 3 seconds
		},
	}
};

export default FulfillmentMixin;
